import Navbar from "@/components/Navbar";
import StickyBar from "@/components/StickyBar";
import ScrollProgress from "@/components/ScrollProgress";
import NicheMarquee from "@/components/NicheMarquee";
import ChatWidget from "@/components/ChatWidget";
import { useEffect } from "react";
import HeroSection from "@/components/sections/HeroSection";
import ProblemSection from "@/components/sections/ProblemSection";
import SolutionSection from "@/components/sections/SolutionSection";
import ModulesSection from "@/components/sections/ModulesSection";
import PortfolioSection from "@/components/sections/PortfolioSection";
import IncomeSection from "@/components/sections/IncomeSection";
import ForWhomSection from "@/components/sections/ForWhomSection";
import PriceSection from "@/components/sections/PriceSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import FAQSection from "@/components/sections/FAQSection";
import FinalCTASection from "@/components/sections/FinalCTASection";
import FooterSection from "@/components/sections/FooterSection";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Die AI Agentur Methode — Baue Websites mit KI | ViraAi";
  }, []);
  return (
    <div
      className="min-h-screen pb-16 md:pb-0"
      style={{ backgroundColor: "#0A0A0A", color: "#F0EDE8", fontFamily: "'Inter', sans-serif" }}
    >
      <ScrollProgress />
      <Navbar />
      <StickyBar />
      <main>
        <HeroSection />
        <PortfolioSection />
        <NicheMarquee />
        <ProblemSection />
        <SolutionSection />
        <IncomeSection />
        <ModulesSection />
        <ForWhomSection />
        <PriceSection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <FooterSection />
      <ChatWidget />
    </div>
  );
}
